import React from 'react';
import styled from 'styled-components';
import YearItem from './YearItem';

const YearsList = ({ data: years, onSetYear, selectedYear }) => {
  return (
    <Container>
      <Title>Seleccione un año *</Title>
      {years.map((year) => (
        <YearItem
          key={year}
          onSetYear={onSetYear}
          selectedYear={selectedYear}
          year={year}
        />
      ))}
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  margin-top: 1em;
`;

const Title = styled.div`
  width: 100%;
  text-align: center;
`;

export default YearsList;
